import { format, isValid } from 'date-fns'

export function formatDatePayload(dateString: string) {
	if (!isValid(new Date(dateString))) return undefined
	return format(new Date(dateString), "yyyy'-'MM'-'dd")
}
